/* sb-dc-fabricfin.js - the finishing list fabric products actually sell.
   2026-10-06, label pass 2026-10-07.

   WHAT WAS WRONG (measured 2026-10-06, Custom Fabric Step and Repeat Banner)
   The design center offered: Hem only, No hem/no grommets, Pole pockets top
   and bottom, Pole pocket top only - and Hem only was the default. The
   product page for the same item sells a different set:

     Grommet with Bravo Tab          <- not offered in the design center
     Pole Pockets (Top and Bottom)
     Pole Pockets (Top Only)
     No Hem & No Grommets
                                     <- Hem only is NOT sold on fabric

   So a customer could design a fabric banner with a finishing we do not make,
   and it was the one selected by default.

   WHAT THIS DOES
   1. Wraps window.__dcFinishingAllowed, which assets/sb-dc-finrail.js reads
      every tick to build the finishing buttons, and returns the fabric set
      instead. Hem only comes out; grommets-only goes in, first, so it is also
      what a fresh board starts on.
   2. Renames grommets-only to "Grommet with Bravo Tab" on fabric, on screen
      AND on the order.

   WHY grommets-only CARRIES BRAVO TAB (the store's call, 2026-10-06)
   The app knows six finishings and none of them is a bravo tab. Inventing an
   id would leave the app guessing at the print geometry and at what to put on
   the order, so the store chose to run it as the nearest real one. Read from
   the app's own table in sb-dc-app.js:

     {id:'grommets-only', labelEn:'No Hem / Grommets Only',
      label:'Grommets Only', inset: 1 inch, hasGrommets: true, pocket:'none'}

   1" inset, grommets, no pocket and no hem - which is how a bravo tab edge is
   printed.

   THE NAME, IN BOTH PLACES (2026-10-07)
   The screen label alone would have left the order reading "No Hem / Grommets
   Only" for a customer who was shown "Grommet with Bravo Tab", and the same
   product ordered from the product page already says Bravo Tab - so the words
   are changed on the cart line too, and the two routes now agree.
   Renaming is done HERE rather than in sb-dc-finrail.js's LABELS table because
   that table is shared: vinyl banners genuinely sell plain "Grommets only"
   with no bravo tab, and must keep saying so.

   SCOPE
   Fabric products only, matched on 'fabric' in the handle - today that is
   fabric-banners, fabric-step-repeat-banners, fabric-step-and-repeat-banner
   and the two 8x8/10x8 fabric pop-up display backdrops. Every other product
   keeps exactly the list and the labels it had.

   The rail re-reads the list every 400ms and, when the selected finishing is
   not in it, calls api.setSpec({finishing: ids[0]}) itself - so a board that
   was already sitting on Hem only moves across on its own rather than ordering
   something we do not make.

   Diagnostics: window.__sbFabricFin()  ·  dry run: window.__sbFabricFin.test({...}) */
(function () {
  'use strict';

  /* The product page's order, so the design center reads the same way. */
  var FABRIC_FINISHING = ['grommets-only', 'pockets-both', 'pockets-top', 'none'];

  var BRAVO_LABEL = 'Grommet with Bravo Tab';
  var BRAVO_HINT = 'Sewn tab with grommet \u00b7 no hem';
  /* What the app writes for grommets-only: labelEn "No Hem / Grommets Only",
     label "Grommets Only". Matched loosely so either spelling is caught. */
  var GROMMETS_ONLY_TEXT = /grommets?\s*only/i;

  var info = { wrapped: 0, handle: '', fabric: false, out: null, relabelled: 0, cartFixed: 0 };
  function diag() { return info; }
  window.__sbFabricFin = diag;

  function handle() {
    try {
      var p = window.__dcAppliedProduct && window.__dcAppliedProduct();
      if (p && p.handle) return String(p.handle).toLowerCase();
    } catch (e) {}
    try {
      var s = window.__dcSelectedProduct;
      if (s && s.handle) return String(s.handle).toLowerCase();
    } catch (e) {}
    return '';
  }

  function isFabric() {
    var h = handle();
    info.handle = h;
    return !!h && h.indexOf('fabric') > -1;
  }

  /* ---- 1. the list ----------------------------------------------------- */

  function wrap() {
    var prev = window.__dcFinishingAllowed;
    if (typeof prev !== 'function' || prev.__sbFabricFin) return;

    var next = function () {
      var ids;
      try { ids = prev.apply(this, arguments); } catch (e) { ids = null; }
      if (!Array.isArray(ids)) return ids;

      info.fabric = isFabric();
      if (!info.fabric) { info.out = null; return ids; }

      /* An empty list means the product has no finishing at all (the pop-up
         backdrop banner-only, flags). Leave that alone - adding options to a
         product that has none is the opposite of the point. */
      if (!ids.length) { info.out = []; return ids; }

      info.out = FABRIC_FINISHING.slice();
      return info.out;
    };
    next.__sbFabricFin = true;
    window.__dcFinishingAllowed = next;
    info.wrapped++;
  }

  /* ---- 2. the name, on screen ------------------------------------------ */

  /* The rail owns the buttons and the dropdown (sb-dc-findropdown.js) copies
     their text, but only rebuilds when the set of ids changes - so both are
     retitled here rather than waiting for a rebuild that may never come. */
  function relabel() {
    if (!isFabric()) return;
    var hit = 0;

    var btn = document.querySelector('#sbdc-finrail button[data-fin="grommets-only"]');
    if (btn) {
      var b = btn.querySelector('b');
      var s = btn.querySelector('small');
      if (b && b.textContent !== BRAVO_LABEL) { b.textContent = BRAVO_LABEL; hit++; }
      if (s && s.textContent !== BRAVO_HINT) { s.textContent = BRAVO_HINT; hit++; }
    }

    var inp = document.querySelector('#sbdc-findrop input[value="grommets-only"]');
    if (inp) {
      var row = inp.parentElement;
      var l = row && row.querySelector('.fd-l');
      var h = row && row.querySelector('small');
      if (l && l.textContent !== BRAVO_LABEL) { l.textContent = BRAVO_LABEL; hit++; }
      if (h && h.textContent !== BRAVO_HINT) { h.textContent = BRAVO_HINT; hit++; }
      /* the closed summary shows the chosen one's name */
      var name = document.querySelector('#sbdc-findrop .fd-name');
      if (inp.checked && name && name.textContent !== BRAVO_LABEL) {
        name.textContent = BRAVO_LABEL; hit++;
      }
    }

    if (hit) info.relabelled += hit;
  }

  /* ---- 3. the name, on the order --------------------------------------- */

  function fixProps(props) {
    if (!props || typeof props !== 'object') return props;
    ['FINISHING OPTIONS', 'Finishing', 'FINISHING'].forEach(function (k) {
      var v = props[k];
      if (typeof v === 'string' && GROMMETS_ONLY_TEXT.test(v)) {
        props[k] = BRAVO_LABEL;
        info.cartFixed++;
      }
    });
    return props;
  }

  /* Exposed so the rewrite can be checked without putting a real order
     through: window.__sbFabricFin.test({'FINISHING OPTIONS':'No Hem / Grommets Only'}) */
  diag.test = function (props) {
    return fixProps(JSON.parse(JSON.stringify(props || {})));
  };

  function isCartAdd(url) {
    try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); } catch (e) { return false; }
  }

  function wrapFetch() {
    var orig = window.fetch;
    if (typeof orig !== 'function' || orig.__sbFabricFinFetch) return;

    var next = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var body = init && init.body;
        if (isCartAdd(url) && isFabric() && typeof body === 'string' && body.indexOf('inishing') >= 0) {
          var data = JSON.parse(body);
          if (data && Array.isArray(data.items)) {
            data.items.forEach(function (it) { if (it && it.properties) fixProps(it.properties); });
          } else if (data && data.properties) {
            fixProps(data.properties);
          }
          init = Object.assign({}, init, { body: JSON.stringify(data) });
        }
      } catch (e) {
        /* never block an order - fall through with the body as it was */
        try { console.warn('[design-center] bravo tab label skipped:', e); } catch (e2) {}
      }
      return orig.apply(this, [input, init]);
    };
    next.__sbFabricFinFetch = true;
    window.fetch = next;
  }

  /* Polled rather than wrapped once: sb-dc-flagopts.js wraps the allowed list
     and sb-dc-cartprops.js wraps fetch, and whoever lands last wins. Taking
     the current one each time keeps every wrapper in the chain. */
  function tick() { wrap(); wrapFetch(); relabel(); }

  tick();
  var t = setInterval(function () { try { tick(); } catch (e) {} }, 400);
  window.addEventListener('pagehide', function () { clearInterval(t); });
})();
